export default {
  custom_option: 'Personnalisé',
  zero_option: 'Sans pourboire',
};
